import React, { useState } from 'react';
import { ChevronUp, ChevronDown, Send, MessageCircle } from 'lucide-react';

export function WelcomeBanner({ t, lang, showWelcome, setShowWelcome, generalEmail, setGeneralEmail, generalMessage, setGeneralMessage, generalSending, generalSent, sendGeneralFeedback, lastUpdate }) {
  const [showForm, setShowForm] = useState(false);

  // Format last update date in the user's locale
  const formatLastUpdate = () => {
    if (!lastUpdate) return null;
    const date = new Date(lastUpdate);
    if (isNaN(date)) return null;
    const locale = lang === 'fr' ? 'fr-FR' : lang === 'pt' ? 'pt-PT' : lang === 'es' ? 'es-ES' : 'en-GB';
    return date.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const formattedDate = formatLastUpdate();

  return (
    <div className="bg-amber-500/[0.07] rounded-xl border border-amber-500/20 mb-4 overflow-hidden">
      <button
        onClick={() => setShowWelcome(!showWelcome)}
        className="w-full flex items-center justify-between px-5 py-3 text-left group"
      >
        <span className="text-sm font-medium text-amber-400">{t('welcomeTitle')}</span>
        {showWelcome
          ? <ChevronUp className="w-5 h-5 text-slate-400 group-hover:text-amber-400 transition-colors" />
          : <ChevronDown className="w-5 h-5 text-slate-400 group-hover:text-amber-400 transition-colors" />
        }
      </button>
      {showWelcome && (
        <div className="px-5 pb-4 border-t border-amber-500/15 pt-3">
          <p className="text-sm text-slate-300 leading-relaxed">
            {t('welcomeText1')} <span className="text-amber-400 font-medium">{t('beta')}</span>{t('welcomeText2')} <span className="text-white font-medium">BMW 3 Series</span>, <span className="text-white font-medium">Mercedes C-Class</span>, and <span className="text-white font-medium">Porsche Macan</span> {t('welcomeText3')}
          </p>

          {formattedDate && (
            <p className="text-xs text-slate-500 mt-2">
              {t('lastUpdate')}: {formattedDate}
            </p>
          )}

          {generalSent ? (
            <div className="text-center text-amber-400 text-sm py-2 mt-3">{t('thanksFeedback')}</div>
          ) : (
            <>
              <button
                onClick={() => setShowForm(!showForm)}
                className="mt-3 flex items-start gap-2.5 text-sm text-amber-400 hover:text-amber-300 transition-colors font-medium text-left"
              >
                <MessageCircle className="w-5 h-5 shrink-0 mt-0.5" />
                <span>{t('welcomeFeedback')}</span>
              </button>
              {showForm && (
                <div className="mt-3 space-y-3 pl-[30px]">
                  <input
                    type="email"
                    placeholder={t('emailPlaceholder')}
                    value={generalEmail}
                    onChange={(e) => setGeneralEmail(e.target.value)}
                    className="w-full bg-slate-900 border border-slate-600 rounded-lg px-3 py-2 text-sm text-white placeholder-slate-500 focus:ring-2 focus:ring-amber-500 outline-none"
                  />
                  <textarea
                    placeholder={t('generalFeedbackPlaceholder')}
                    value={generalMessage}
                    onChange={(e) => setGeneralMessage(e.target.value)}
                    rows={2}
                    className="w-full bg-slate-900 border border-slate-600 rounded-lg px-3 py-2 text-sm text-white placeholder-slate-500 focus:ring-2 focus:ring-amber-500 outline-none resize-none"
                  />
                  <button
                    onClick={sendGeneralFeedback}
                    disabled={generalSending || !generalEmail || !generalMessage}
                    className="bg-amber-500 hover:bg-amber-600 disabled:opacity-50 disabled:cursor-not-allowed px-4 py-2 rounded-lg font-medium transition-colors text-sm flex items-center gap-2 text-slate-900"
                  >
                    <Send className="w-4 h-4" />
                    {generalSending ? t('sending') : t('send')}
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default WelcomeBanner;
